export const TOKEN_AUTH_INCOMPLETE = 'TOKEN_AUTH_INCOMPLETE';
export const REQUEST_AUTH_TOKEN_ERROR = 'REQUEST_AUTH_TOKEN_ERROR';
